import { slice } from "./slice";
import * as defaultActions from "../../../redux/_helpers";
import * as constants from "./constants";
import { get } from "../../../api/requester";
import { Access } from "../usePageAccessHook";

const { actions } = slice;

export const getUserOrgUnits = () => async dispatch => {
  try {
    const res = await get(constants.API.getOrgUnits);
    dispatch(actions.setUserOrgUnits(res));
    return res;
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};

export const getAppParameters = () => async dispatch => {
  try {
    const res = await get(constants.API.getAppParameters);
    const fieldsDict = res.reduce((a, e) => ({
      ...a,
      [e.name]: e
    }), {});
    dispatch(actions.setUserFields(fieldsDict));
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
}

export const getUserMenu = () => async dispatch => {
  try {
    const res = await get(constants.API.getUserMenu);
    dispatch(actions.setUserMenus(res));
    dispatch(actions.setRedirectUrl(res[0]?.url || "/"));
    return res;
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};

export const fetchSubMenuItems = menuID => async dispatch => {
  try {
    const items = await get(constants.API.getUserMenu, { ParentId: menuID });
    dispatch(actions.fetchSubMenuItems({ items, menuID }));
    return items;
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};

export const setTabMenuItems = items => dispatch => {
  dispatch(actions.setTabMenuItems({ items }));
};

export const getUserAccess = pageUrl => async dispatch => {
  try {
    const res = await get(constants.API.getPageAccess, { Url: pageUrl });
    if (typeof res === "number") {
      return res === 0 ? Access.WRITE : Access.READ;
    } else {
      return null;
    }
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
};

export const setUserAccess = access => dispatch => {
  dispatch(actions.setUserAccess(access));
};

export const getCurrentUser = () => async (dispatch) => {
  try {
    const res = await get('/api/User/Details');
    dispatch(actions.setUserDetails(res));
  } catch (errors) {
    const message = defaultActions.getResponseErrorMessage(errors, "Error occurred!");
    dispatch(actions.catchError({ errors: message, callType: "actionsLoading", errorProp: "errorAction" }));
  }
}
